<template>
  <div class="beleza-page">
    <header class="hero">
        <div class="logo">
            <img src="@/assets/landpages/beleza/images/logo-horabela.png" alt="Logo Horabela">
        </div>

        <div class="hero-content">
            <h1>Gestão profissional para o seu negócio de beleza brilhar</h1>
            <p>Automatize comissões, simplifique agendamentos e recupere o controle financeiro do seu estabelecimento com uma ferramenta feita para o seu negócio.</p>

            <a href="https://app.horabela.com.br/registro" class="cta" id="cta_hero_beleza">Começar teste gratuito</a>

            <p class="trial-info">30 dias grátis — Sem cartão de crédito</p>
        </div>

        <div class="hero-media">
            <img src="@/assets/landpages/beleza/images/dashboard.png" alt="Sistema Horabela para Beleza">
        </div>
    </header>

    <section class="benefits">
        <h2>Tudo o que o seu negócio precisa em um só lugar:</h2>
        <ul>
            <li>✅ <b>Comissões Automáticas:</b> Sem erros e sem perda de tempo nos cálculos da equipe.</li>
            <li>✅ <b>Check-out Inteligente:</b> Registro rápido de serviços, vendas e formas de pagamento.</li>
            <li>✅ <b>Gestão de Estoque:</b> Controle de produtos vendidos e calcule a comissão da venda.</li>
            <li>✅ <b>Saúde Financeira:</b> Relatórios claros sobre faturamento, custos e lucro líquido.</li>
            <li>✅ <b>Acesso Remoto:</b> Controle seu negócio de qualquer lugar pelo celular ou tablet.</li>
        </ul>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center" id="cta_beneficios_beleza">Quero organizar meu espaço</a>
    </section>

    <section class="for-who">
        <h2>Feito para todos os especialistas em beleza:</h2>
        <ul>
            <li>✨ <b>Salões de Cabeleireiro e Barbearias</b></li>
            <li>✨ <b>Clínicas de Estética e Spas</b></li>
            <li>✨ <b>Studios de Nails e Sobrancelhas</b></li>
            <li>✨ <b>Maquiadores e Micropigmentadores</b></li>
        </ul>
    </section>

    <section class="pricing">
        <h2>Planos que impulsionam o seu crescimento</h2>
        <p class="pricing-intro">Escolha o plano ideal para a estrutura atual do seu estabelecimento e tenha todas as ferramentas de gestão profissional à sua disposição.</p>

        <div class="pricing-grid">
            <div class="pricing-card">
                <h3>Profissional Único</h3>
                <div class="price">R$ 10<span>/mês</span></div>
                <p>Ideal para especialistas autônomos</p>
                <ul>
                    <li>✅ Gestão Financeira Completa</li>
                    <li>✅ Controle de Estoque e Insumos</li>
                    <li>✅ Histórico Digital de Clientes</li>
                    <li>✅ Suporte Especializado</li>
                </ul>
                <a href="https://app.horabela.com.br/registro" class="cta-plan">Assinar Agora</a>
            </div>

            <div class="pricing-card featured">
                <div class="badge">MAIS UTILIZADO</div>
                <h3>Studio Duplo</h3>
                <div class="price">R$ 20<span>/mês</span></div>
                <p>Para espaços com 2 profissionais</p>
                <ul>
                    <li>✅ Divisão Automática de Comissões</li>
                    <li>✅ Relatórios de Performance</li>
                    <li>✅ Todas as funcionalidades liberadas</li>
                    <li>✅ Suporte via WhatsApp</li>
                </ul>
                <a href="https://app.horabela.com.br/registro" class="cta-plan">Assinar Agora</a>
            </div>

            <div class="pricing-card">
                <h3>Equipe Master</h3>
                <div class="price">R$ 30<span>/mês</span></div>
                <p>Gestão completa para 3 profissionais</p>
                <ul>
                    <li>✅ Controle Total de Fluxo de Caixa</li>
                    <li>✅ Auditoria de Vendas e Serviços</li>
                    <li>✅ Multiusuário e Multiplataforma</li>
                    <li>✅ Suporte Prioritário</li>
                </ul>
                <a href="https://app.horabela.com.br/registro" class="cta-plan">Assinar Agora</a>
            </div>
        </div>

        <p class="pricing-footer">Precisa de mais profissionais? <a href="https://wa.me/5581996280480" style="color: #ff7f50;">Fale com nosso comercial.</a></p>
    </section>

    <section class="faq">
        <h2>Dúvidas Frequentes</h2>

        <div class="faq-item">
            <button class="faq-question">O sistema serve para estabelecimentos pequenos?</button>
            <div class="faq-answer">
                <p>Sim! O Horabela atende desde profissionais autônomos até grandes centros de beleza com múltiplas cadeiras.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Consigo configurar diferentes porcentagens de comissão?</button>
            <div class="faq-answer">
                <p>Com certeza. Você pode definir regras personalizadas por profissional ou por tipo de serviço realizado.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Posso cancelar quando quiser?</button>
            <div class="faq-answer">
                <p>Pode sim. Não tem fidelidade e você cancela quando quiser.</p>
            </div>
        </div>

                <div class="faq-item">
            <button class="faq-question">Preciso colocar cartão para testar?</button>
            <div class="faq-answer">
                <p>Não precisa. Você testa grátis sem colocar cartão e sem compromisso.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Funciona no celular?</button>
            <div class="faq-answer">
                <p>Sim. Funciona no celular, tablet e computador.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">O cálculo de comissão é automático?</button>
            <div class="faq-answer">
                <p>Sim. O sistema calcula tudo sozinho, por serviço e por barbeiro.</p>
            </div>
        </div>
        
        <a href="https://wa.me/5581996280480" class="cta cta-center" id="cta_faq_beleza">Falar com um consultor</a>
    </section>

    <footer>
        <p>Horabela © Gestão Inteligente para o Mercado da Beleza</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Beleza',
  data() {
    return {
      // Suas variaveis de dados aqui
    }
  },
  mounted() {
    // FAQ Toggle
    const questions = document.querySelectorAll('.faq-question');
    questions.forEach(q => {
        q.addEventListener('click', () => {
            const answer = q.nextElementSibling;
            answer.classList.toggle('open');
            q.classList.toggle('active');
        });
    });
  },
  methods: {
    // Seus metodos aqui
  }
}
</script>

<style scoped>
@import '@/assets/landpages/beleza/css/styles.css';
</style>
